<template>
    <div class="demo-inline-spacing">
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="danger"
            class="mt-0 btn-icon"
            @click="$emit('remove')"
            v-if="showRemove"
        >
            <feather-icon icon="Trash2Icon"/>
        </b-button>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-0"
            @click="request"
            v-if="showSendRequest"
        >
            {{ $t('Component(Button):send-request') }}
        </b-button>
        <b-button
            v-if="isScipNotificationButtonVisible"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :variant="scipNotificationButtonVariant"
            :class="{'mt-0': true, 'text-decoration-line-through': false === scipNotificationFacts.isNotificationGranted}"
            :disabled="isScipNotificationButtonDisabled"
            @click="makeSCIPNotification"
        >
            {{ $t(scipNotificationButtonText) }}
        </b-button>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-0"
            @click="save"
            v-if="showSave"
        >
            {{ $t('Component(Button):save') }}
        </b-button>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-0"
            @click="close"
            v-if="showClose"
        >
            {{ $t('Component(Button):close') }}
        </b-button>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-0"
            @click="$emit('back')"
            v-if="showBack"
        >
            {{ $t('Component(Button):back') }}
        </b-button>
    </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
    components: {
        BButton
    },
    props: {
        showSave: {
            type: Boolean,
            default: true,
        },
        showClose: {
            type: Boolean,
            default: true,
        },
        showSendRequest: {
            type: Boolean,
            default: true,
        },
        showRemove: {
            type: Boolean,
            default: false,
        },
        showBack: {
            type: Boolean,
            default: false,
        },
        scipNotificationFacts: {
            type: Object,
            default() {
                return {
                    isNotificationGranted: false,
                    isSubscriberProperlyConfigured: false,
                    productDecision: {
                        canBeNotified: false,
                        hasChangesToBeReported: false,
                        hasSubstancesAboveSpecifiedConcentrationRange: false,
                        hasScipNumbersOnComponentLevel: false,
                        hasScipNumberReference: false
                    },
                    sandBoxSettings: null
                }
            }
        },
        isScipNotificationButtonVisible: {
            default: true
        }
    },
    directives: {
        Ripple
    },
    methods: {
        close() {
            this.$emit('close');
        },
        save() {
            this.$emit('save');
        },
        request() {
            this.$emit('sendRequest')
        },
        makeSCIPNotification() {
            this.$emit('makeSCIPNotification');
        }
    },
    computed: {
        scipNotificationButtonVariant() {
            if (this.isScipNotificationButtonDisabled) {
                return 'primary';
            }
            return 'primary';
        },
        scipNotificationButtonText() {
            if (this.scipNotificationFacts.isNotificationGranted) {
                return 'Component(Button):make-scip-notification';
            }
            return 'Component(Button):make-scip-notification';
        },
        isScipNotificationButtonDisabled() {
            return false === this.scipNotificationFacts.productDecision.hasSubstancesAboveSpecifiedConcentrationRange
                && false === this.scipNotificationFacts.productDecision.hasScipNumbersOnComponentLevel
                && false === this.scipNotificationFacts.productDecision.hasScipNumberReference;
        },
    }
}
</script>
